// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcc35970","609":"acb01a9f","625":"28975508","649":"d0a4a1d3","652":"3c6758b3","674":"d55c8606","863":"89b93210","872":"57e0ea8f","900":"5f89728a"}[chunkId] + ".chunk.js";
};